<template>
  <div id="chat-key-list">
    <div class="tape" @click="$router.push({name:'question'})">
      <span class="href topic">Tape问题汇总</span>
      <i class="el-icon-arrow-right"></i>
    </div>
    <div class="box">
      <div v-for="(item, idx) in keys" :key="idx" class="keyword">
        <span
          class="href"
          :class="{finish:item.status === 1}"
          @click="$emit('toMessage',item)"
        >{{item.title}}</span>
        <i
          class="process"
          :class="{finished:item.status === 1} "
        >{{item.status === 1 ? "完成" : "讨论中"}}</i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: { keys: Array },
  methods: {
    toMessage(item) {}
  }
};
</script>
<style lang="scss" scoped>
#chat-key-list {
  // padding: 0 30px;
  .keyword:hover {
    background: hsla(219, 19%, 97%, 0.9);
  }
  .tape {
    height: 50px;
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: hsla(0, 0%, 20%, 1);
    border-bottom: 1px solid hsla(0, 0%, 90%, 1);
  }
  .box {
    height: 585px;
    overflow-y: auto;
    .keyword {
      margin: 0 30px;
      height: 50px;
      width: calc(100% - 60px);
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid hsla(0, 0%, 90%, 1);
      cursor: pointer;
      // border: 1px dashed red;
      .href {
        width: calc(100% - 50px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: hsla(0, 0%, 20%, 1);
        font-size: 14px;
      }
      .href.finish {
        color: hsla(0, 0%, 40%, 1);
      }
      .process {
        border-radius: 3px 3px 3px 0;
        background: hsla(46, 100%, 78%, 1);
        color: hsla(0, 0%, 20%, 1);
        font-size: 12px;
        font-style: normal;
        width: 50px;
        padding: 0.3em 0.5em;
        text-align: center;
      }
      .finished {
        background: hsla(120, 54%, 80%, 1);
      }
    }
  }
}
</style>